import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultarCumplimientosFormComponent } from '../consultar-cumplimientos-form.component';

/**
 * Orientaciones No Programadas - Consulta de cumplimientos rechazados.
 * Legacy: FilterCumplimNoProgViewImpl
 * Reutiliza el formulario compartido con tipo='NO_PROGRAMADA'
 */
@Component({
  selector: 'app-orientaciones-no-programadas',
  standalone: true,
  imports: [CommonModule, ConsultarCumplimientosFormComponent],
  template: `
    <div>
      <h2 class="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-4">
        Orientaciones No Programadas
      </h2>
      <app-consultar-cumplimientos-form tipo="NO_PROGRAMADA" />
    </div>
  `
})
export class OrientacionesNoProgramadasComponent {}
